import React, { useContext, useEffect, useRef, useState } from "react";
import ObjectHead from "../ObjectHead/ObjectHead";
import ObjectSearch from "../ObjectSearch/ObjectSearch";
import { popupcontext } from "../../../../context/Popupscontext";
import useOutsideClick from "../../../Helpers/OutsideClick/useOutsideClick";
import ObjectTable from "../ObjectTable/ObjectTable";
import { NavLink, useLocation } from "react-router-dom";
import { isRTL } from "../../../../utils";
import usePermission from "../../../../hooks/usePermission";

export default function ObjectDetails() {
	let { pathname } = useLocation();
	const getShortPath = () => pathname.split("/").pop();

	let {
		setObjectselect,
		historyPlayback,
		setHistoryPlayback,
		isControlsPopup,
	} = useContext(popupcontext);
	const obj = useRef(null);
	useOutsideClick(
		obj,
		() => {
			if (!isControlsPopup) {
				setObjectselect(false);
			}
		},
		"mousedown"
	);

	useEffect(() => {
		return () => setHistoryPlayback(false);
	}, [setHistoryPlayback]);
	const [type, setType] = useState("vehicle");
	const { view } = usePermission("LIVETRACKINGHISTORY");
	return (
		<div ref={obj}>
			<div
				className={`bg-white-rounded p-0 object-details  ${
					isRTL ? "object-details-rtl" : "object-details-ltr"
				}`}
			>
				<ObjectHead setType={setType} type={type} />
				<div className="H-line"></div>
				<ObjectSearch />
				<div className="H-line"></div>
				<ObjectTable type={type} />
				{historyPlayback.state && view && (
					<>
						<div className="H-line"></div>
					</>
				)}
				{historyPlayback.state &&
					getShortPath(pathname) === "livetracking" &&
					view && (
						<NavLink to={`/historyplayback/${historyPlayback.Id}`}>
							<div className="histroy-playback">
								<div className="img-wrapper">
									<img
										src={`${process.env.PUBLIC_URL}/assets/HistoryPlayBack.svg`}
										alt="historyplayback"
									/>
								</div>
							</div>
						</NavLink>
					)}
			</div>
		</div>
	);
}
